module.exports = __webpack_public_path__ + "img/510.general.fe922d5a.svg";